// import CampaignTable from '../../components/campaigns/CampaignTable';
import { useSelector } from 'react-redux'
import TeamsTable from '../../components/teams/TeamsTable';
import adminLogo from '../../Images/admin_img.jpg'

const Wrapper = () => {
  // const { isLoggedIn, setIsLoggedIn } = useContext(UserIsLoggedIn);
  // const {userId} = useParams();
  const isSuperuser = useSelector((state) => state.user.isSuperuser);
  const image = useSelector((state) => state.user.image);

  return(
    <>
      <div 
            className='table-container' 
            style={{
            paddingBottom: '2rem',
            backgroundImage: `url("${isSuperuser ? adminLogo : image}")`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            minHeight: '90vh',
            position: 'relative' // Needed for overlay positioning
            }}
        >
            <div
            className='table-inner-div'
            style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                zIndex: 0 // Below content
            }}
            />
        <TeamsTable/>
      </div>
    </>
  );
}
export default Wrapper;